import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/public/play1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/public/play2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/public/play3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/src/app/play/page.module.css");
